const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectTypeCircleBioEnergy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.671371,
    y: 0.671371,
    width: 30.8831,
    height: 30.8831,
    rx: 15.4415,
    stroke: "#FF865D",
    style: {
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1268 21.4839V20.4769C18.1268 19.26 19.4502 18.109 20.3087 17.2879C21.5189 16.131 22.155 14.5768 22.155 12.7561C22.155 9.39925 19.4809 6.71377 16.1127 6.71377C15.3186 6.71155 14.5318 6.86633 13.7978 7.1692C13.0637 7.47207 12.3967 7.91706 11.8352 8.47859C11.2736 9.04011 10.8286 9.7071 10.5258 10.4412C10.2229 11.1753 10.0681 11.962 10.0703 12.7561C10.0703 14.5117 10.7337 16.1713 11.9166 17.2879C12.7705 18.0939 14.0986 19.2474 14.0986 20.4769V21.4839M14.7699 25.5122H17.4554M14.0986 23.498H18.1268M16.1127 21.4839V13.4275",
    stroke: "#FF865D",
    style: {
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2695 16.4484C17.586 17.121 17.049 17.4555 16.1133 17.4555C15.1777 17.4555 14.6406 17.121 13.9572 16.4484",
    stroke: "#FF865D",
    style: {
      stroke: "#FF865D",
      stroke: "color(display-p3 1.0000 0.5255 0.3647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.34274,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeCircleBioEnergy);
export default __webpack_public_path__ + "static/media/project-type-circle-bio-energy.caedbfe44a99c38bdab42be9db1aabc8.svg";
export { ForwardRef as ReactComponent };